module.exports = __webpack_public_path__ + "img/TF-Logo-horizontal-OK.a78d37f7.png";